// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2uDdg","header":"style_header__3t1sb"};